import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  margin-bottom: 15px;
`

export const LabelRow = styled.div`
  display: grid;
  grid-template-columns: ${({ enableEditting }) =>
    `repeat(${enableEditting ? 6 : 5}, 1fr)`
  };
  gap: 10px;
  justify-content: center;
  align-items: center;
  justify-items: center;
  margin: 0px 10px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 5px;
`
